import { RoundedIcon } from '@components/RoundedIcon';
import { IconTriangleCaution } from '@endurancewarranty/icons';
import { cx } from '@endurancewarranty/ui';

import type { FC } from 'react';

type Props = Readonly<{
  className?: string;
  iconClassName?: string;
  size?: 'sm' | 'md' | 'lg';
}>;

export const RedTriangleCaution: FC<Props> = ({ size, className, iconClassName }) => {
  return (
    <RoundedIcon backgroundClassName={cx('bg-red-100', className)} size={size}>
      <IconTriangleCaution className={cx('text-red-600', iconClassName)} width={32} />
    </RoundedIcon>
  );
};
